<template>
  <div class="text-slate">
    <h2 class="title mb-6 text-sm uppercase tracking-[.12em] md:mb-8">
      {{ $t('frequent_search_queries') }}
    </h2>

    <ul class="flex flex-col">
      <li
        v-for="(item, i) in items"
        :key="i"
        class="mb-6 flex cursor-pointer items-center text-md"
        @click="selectItem(item)"
      >
        <UiIcon icon="search" class="mr-4"></UiIcon>
        <span>{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
interface Props {
  items?: any[];
}
interface Emits {
  (e: 'update:modelValue', data: string): void;
}

withDefaults(defineProps<Props>(), {
  items: () => [],
});

const emit = defineEmits<Emits>();

const selectItem = (item: string) => {
  emit('update:modelValue', item);
};
</script>
